module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-3-a4569c0f58241f39e0d48aadeab14185.jpg";